import React, { useEffect, useState } from 'react';
import { Clock, Zap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { YikiLatestResult, YikiResultHistory } from './YikiLatestResult';
import { formatYikiCountdown, formatYikiPayout } from '../../utils/yikiUtils';

export function YikiRoundPanel({ room, round, remainingTime, drawHistory }) {
  const [displayTime, setDisplayTime] = useState(remainingTime);
  const latestDraw = drawHistory[0];

  useEffect(() => {
    setDisplayTime(remainingTime);
  }, [remainingTime]);

  useEffect(() => {
    if (!displayTime || displayTime.isExpired) return undefined;

    const timer = setInterval(() => {
      setDisplayTime((prev) => {
        if (!prev || prev.isExpired) return prev;
        let { days, hours, minutes, seconds } = prev;
        if (seconds > 0) seconds -= 1;
        else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        } else if (days > 0) {
          days -= 1;
          hours = 23;
          minutes = 59;
          seconds = 59;
        } else {
          return { ...prev, isExpired: true };
        }
        return { days, hours, minutes, seconds, isExpired: false };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [displayTime]);

  if (!room || !round) return null;

  return (
    <Card className="border-2 border-brand-gold/40 bg-gradient-to-br from-white to-brand-gold-light/20">
      <CardHeader className="border-brand-gold/20 bg-brand-red/5">
        <CardTitle className="flex items-center gap-2 text-brand-red">
          <Zap className="h-5 w-5 text-brand-gold" />
          {room.name}
        </CardTitle>
        <p className="text-sm text-gray-600">{room.label}</p>
      </CardHeader>
      <CardContent className="space-y-5">
        <YikiLatestResult
          result={latestDraw?.result}
          roundNumber={latestDraw?.roundNumber}
          variant="hero"
        />

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          <div className="rounded-xl border border-red-100 bg-white p-3 text-center">
            <p className="text-xs text-gray-500">รอบถัดไป</p>
            <p className="text-xl font-bold text-brand-red">#{round.roundNumber}</p>
          </div>
          <div className="rounded-xl border border-brand-gold/50 bg-brand-gold-light/30 p-3 text-center">
            <p className="text-xs text-gray-500">2 ตัวท้าย</p>
            <p className="text-sm font-bold leading-tight text-brand-gold sm:text-base">
              {formatYikiPayout(room.multiplierTwo)}
            </p>
          </div>
          <div className="rounded-xl border border-brand-red/30 bg-red-50/50 p-3 text-center">
            <p className="text-xs text-gray-500">3 ตัวตรง</p>
            <p className="text-sm font-bold leading-tight text-brand-red sm:text-base">
              {formatYikiPayout(room.multiplierThree)}
            </p>
          </div>
          <div className="col-span-2 rounded-xl border border-red-100 bg-white p-3 text-center sm:col-span-1">
            <p className="flex items-center justify-center gap-1 text-xs text-gray-500">
              <Clock className="h-3 w-3" />
              ออกรางวัลใน
            </p>
            <p className="font-mono text-xl font-bold text-brand-red">
              {formatYikiCountdown(displayTime)}
            </p>
          </div>
        </div>

        <YikiResultHistory items={drawHistory} />
      </CardContent>
    </Card>
  );
}
